import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { INVALID_PHONE_MESSAGE, INVALID_TIME_MESSAGE } from '../../constants/messages';
import { ValidationError } from '../errors';
export var assertResponseValidationError = function assertResponseValidationError(result, domain) {
  if (result.date) {
    return;
  }
  var errors = result.errors || [];
  var validationErrors = errors.reduce(function (acc, item) {
    if (item.key === 'customerPhone') {
      return _objectSpread(_objectSpread({}, acc), {}, {
        customerPhone: INVALID_PHONE_MESSAGE
      });
    }
    if (item.key === 'time') {
      return _objectSpread(_objectSpread({}, acc), {}, {
        time: INVALID_TIME_MESSAGE
      });
    }
    return acc;
  }, {});
  if (Object.values(validationErrors).length) {
    throw new ValidationError({
      domain: domain,
      message: 'Request callback response validation error',
      errors: validationErrors
    });
  }
};